import { NavigationBar } from '@devrangex/rui'
import styled from '@emotion/styled'
import { useQuery } from '@tanstack/react-query'
import { useEffect, useLayoutEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'

import { fetchMe } from '../api'
import logoPrimary from '../assets/logo-primray.svg'
import BayGrid from '../components/home/bay/BayGrid'
import SettingMenu from '../components/settings'
import { meState } from '../store/user'
import { PageLayout } from '../styles/layouts'
import Sentry from '../utils/Sentry'


const NavigationContainer = styled.div`
    flex-grow: 1;
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo {
        margin-top: 6px;
    }

    .title {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        ${({theme}) => theme.font.heading3}
    }
`

const Contents = styled.div`
    position: relative;
    padding: 0 56px;
`

const Head1 = styled.h1`
    color: #fff;
    text-align: center;
    font-size: 44px;
    font-weight: 600;
    margin: 60px 0;
`

const useFetchMe = () => {
  const navigate = useNavigate()
  const [me, setMe] = useRecoilState(meState)

  const {isLoading, data, isError} = useQuery({
    queryKey: ['fetchMe'],
    queryFn: fetchMe,
    retry: false,
  })

  useLayoutEffect(() => {
    if (data) {
      setMe(data)
    }

    if (isError) {
      navigate('/login', {replace: true})
    }
  }, [setMe, isError, navigate, data])

  // 센트리 스코프 - 유저정보 설정
  useEffect(() => {
    if (!me) return

    Sentry.configureScope((scope) => {
      scope.setUser({
        id: me.id,
        username: me.name,
        shopID: me.shopID,
        shopName: me.Shop?.shopName,
      })
    })
  }, [me])

  return {
    isLoading,
    me,
  }
}

export default function HomePage() {
  const {isLoading, me} = useFetchMe()

  if (isLoading) {
    return '로딩중'
  }

  return (
    <PageLayout>
      <NavigationBar kiosk role="navigation">
        <NavigationContainer>
          <img className="logo" src={logoPrimary} alt="logo"/>
          <span className="title">{me?.Shop?.shopName}</span>
          <SettingMenu/>
        </NavigationContainer>
      </NavigationBar>

      <Contents>
        <Head1>이용할 타석을 선택하세요</Head1>

        <BayGrid/>
      </Contents>
    </PageLayout>
  )
}
